var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSynchronize = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.843,217.174A398.736,398.736,0,0,0,500,100c-195.291,0-357.892,139.936-393,325H261.391a250.117,250.117,0,0,1,415.4-101.776L575.005,425H825.02a50,50,0,0,0,50-50V125ZM738.609,575a250.117,250.117,0,0,1-415.4,101.777L425,575H174.98a50,50,0,0,0-50,50V875l92.18-92.174A398.736,398.736,0,0,0,500,900c195.291,0,357.892-139.936,393-325H738.609Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSynchronize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Synchronize.a5bc48f4.svg";
export { ForwardRef as ReactComponent };